<style scoped>
  /* .about-holder{
    display: flex;
    flex-direction: column;
    align-items: center;
    text-align: center;
  } */
  
  .avats {
    display: flex;
    flex-direction: row;
    flex-flow: wrap;
    overflow-y: scroll;
    height: 100%;
    padding: 10px;
  }

  .avats > img {
    width: 80px !important;
    height: 80px !important;
    margin: 3px auto;
    border-radius:100%;
    border:5px solid #ddd;
  }
</style>

<style>
  /* .about-mynd > .ivu-modal > .ivu-modal-content > .ivu-modal-header{
    border-bottom: 0;
  } */
</style>


<template>
  <ModalHolder title="" m-top="30" m-height="70vh"
     class-name="avatar-picker"
    :is-show="avatarPicker">
    <template slot="mheader">
        <div style="display: flex; justify-content: flex-end;">
            <span @click="avatarPicker = false">
                <img :src="closeIcon" style="height: 25px;"/>
            </span>
        </div>
    </template>
    <template slot="mcontent">
        <div v-if="!isLoading">
            <div class="avats">
                <img 
                v-for="(avatar, i) in avatarList"
                :key="i"
                :id="'avatar-' + i"
                :src="avatar"
                @click="avatarPick(avatar)"/>
            </div>
        </div>
        <div v-else>
            Loading ...
        </div>
    </template>
  </ModalHolder>
</template>

<script>
import ModalHolder from "@/components/ModalHolderComponent";

export default {
  name: 'AvatarPickerModal',
  components: {
    ModalHolder
  },
  data() {
      return {
          isLoading: false
      }
  },
  mounted() {
      if (this.avatars.length == 0) {
          this.loadImageLibrary()
      }
  },
  computed: {
    avatarList() {
      let avatarArray = []

      Object.keys(this.avatars).forEach(key => {
        this.avatars[key].forEach(avatar => {
          avatarArray.push(this.baseUrl + key + '/' + avatar)
        })
      })

      return avatarArray
    },
    avatars: {
      get() {
        return this.$store.state.user.avatars.images || []
      }
    },
    avatarPicker: {
      get() {
        return this.$store.state.publicProfile.showAvatarPicker
      },
      set(v) {
          this.$store.commit('publicProfile/setAvatarPicker', v)
      }
    },
    closeIcon: {
      get() {
        return require('@/assets/close.png')
      }
    },
    baseUrl: {
      get() {
        return this.$store.state.user.avatars.base_url
      }
    }
  },
  methods: {
      loadImageLibrary() {
          this.isLoading = true
          this.$store.dispatch("user/getImageLibraries")
            .then(res => {
                this.isLoading = false
            },
            error => {
                this.isLoading = false
            })
      },
      avatarPick(url) {
        this.$emit('avatarPick', url)
        this.avatarPicker = false
      }
  }
}

</script>
